import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GeneratedContentUpdateInput, GeneratedContentUpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentUpdateInput;
type TData = GeneratedContentUpdatePayload;

export const useContentUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentUpdate($input: GeneratedContentUpdateInput!) {
      generatedContentUpdate(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
